import { Button } from '@mui/material'
import { memo, useCallback, useMemo } from 'react'
import { checkPublicRoute } from '../../../../../../utils/utils'
import { useLocation, useNavigate } from 'react-router-dom'
import Icon from '../../../../../../components/icon'

const GoBackButton = ({
  publicId = null,
  contestUri,
  assessment,
  contestId
}) => {
  // Hooks
  const navigate = useNavigate()
  const { state } = useLocation()

  // Variable
  const isPublicRoute = useMemo(() => {
    return checkPublicRoute()
  }, [])

  // Handlers
  const handleNavigate = useCallback(() => {
    navigate(
      isPublicRoute && publicId
        ? `/share/${publicId}`
        : state?.pathname
        ? state?.pathname
        : contestUri
        ? `/c/${contestUri}/stages`
        : `/${
            assessment ? 'assessments' : 'contests'
          }/${contestId}/edit?active=dashboard`,
      {
        replace: true
      }
    )
  }, [
    navigate,
    state,
    contestUri,
    isPublicRoute,
    publicId,
    assessment,
    contestId
  ])

  return (
    <Button
      color="error"
      variant="outlined"
      className="editor-btn"
      onClick={handleNavigate}
      startIcon={
        <Icon icon="lets-icons:back-light" style={{ fontSize: '14px' }} />
      }
      sx={{ padding: '5px 10px', fontSize: '12px' }}
    >
      Go Back
    </Button>
  )
}

export default memo(GoBackButton)
